import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ChartsAndTables = lazy(() => import("@/pages/ChartsAndTables"));

export const Route = createFileRoute("/diagram-tabeller")({
  head: () => seoHead("/diagram-tabeller"),
  component: () => <ChartsAndTables />,
});
